<ng-content></ng-content>

<div class="time-labels">
  <div class="time-start">{{ session.startedAt | date: 'short' }}</div>
  <div class="time-end">{{ session.finishedAt | date: 'shortTime' }}</div>
</div>
